import { Flex } from "components/Base";
import { useEffect } from "react";
import useChatStore from "./chatStore";
import EmptyChat from "./components/EmptyChat";
import MainContent from "./components/MainContent";
import SideContent from "./components/SideContent";

function Chat() {
  const chatRoomList = useChatStore((s) => s.chatRoomList);
  const getChatRoomList = useChatStore((s) => s.getChatRoomList);

  useEffect(() => {
    const params = {
      page: 1,
    };

    getChatRoomList(params);
  }, []);

  if (chatRoomList.length === 0) {
    return <EmptyChat />;
  }

  return (
    <Flex w="100%" gap="16px">
      <SideContent />
      <MainContent />
    </Flex>
  );
}

export default Chat;
